import { Fab } from '@material-ui/core'
import React, { FC, ReactElement } from 'react'
import Icon, { IconName } from '../Icon'
import { IconSize } from '../../../../NonReact/constants/React/Icon/Constants'
import { IsVarEmpty } from '../../../../NonReact/utils/GlobalFunctions'

type BaseProps = {
    className?: string
    iconName: IconName
    size?: 'small' | 'medium' | 'large'
    href?: string
    onClick?: () => void
}

type StandardFABProps = {
    isExtended: false
    content?: undefined
}

type ExtendedFABProps = {
    isExtended: true
    content?: string
}

type Props = BaseProps & (StandardFABProps | ExtendedFABProps) & { iconSize?: IconSize }

/**
 * Floating Action Button - Display a rounded button with an icon and optional text.
 *
 * @param isExtended - If true, the button will be extended and display text.
 * @param content - The text to display if the button is extended.
 * @param className - The class name to apply to the button.
 * @param iconName - The icon to display on the button.
 */
export const FAB: FC<Props> = ({
    isExtended,
    iconName,
    content,
    size,
    href,
    onClick,
    className,
    iconSize
}: Props): ReactElement => {
    const optionalProps: Record<string, unknown> = {
        href,
        target: href ? '_blank' : undefined,
        onClick
    }

    return (
        <Fab
            className={`floating-action-button ${className}`}
            variant={isExtended ? 'extended' : 'circular'}
            size={size ?? 'medium'}
            {...optionalProps}
        >
            <Icon iconSize={IsVarEmpty(iconSize) ? IconSize.MEDIUM : iconSize} iconName={iconName} />
            {isExtended ? <span className='fab-content'>{content}</span> : <></>}
        </Fab>
    )
}
